import Vue from 'vue'
var twitchHeader = {
  headers: {
    'Client-ID': 'oj79pe90wcf8nan97jzuy6dm2h7fh0',
    'Authorization': 'Bearer mvktwv96r7jo7ul3zkzqotlc6gt516',
    'Accept': 'application/vnd.twitchtv.v5+json'
  }
}

/*eslint-disable */
export default {
  isStreamLive (channelName) {
    var url = 'https://api.twitch.tv/helix/streams?user_login=' + channelName
    var p1 = new Promise(function (resolve, reject) {
      Vue.http.get(url, twitchHeader).then(response => {
        resolve(response)
      }, response => {
        // error goes here
        reject(response)
      })
    })
    return p1
  },
  getChannelInfo (channelId) {
    var url = 'https://api.twitch.tv/helix/users/follows?to_id=' + channelId
    var p1 = new Promise(function (resolve, reject) {
      Vue.http.get(url, twitchHeader).then(response => {
        resolve(response)
      }, response => {
        // error goes here
        reject(response)
      })
    })
    return p1
  }
}



// WEBPACK FOOTER //
// ./src/gateways/twitch.js